<template>
  <div class="page-header sticky-page-header">
    <sticky class="page-header sticky-page-header">
      <span v-if="total !== null" slot="left-title">{{total}}&nbsp;
        <span v-if="label">{{ labelPlurialize }}&nbsp;</span>
        <span v-if="helper" v-helper.bottomLeft="helper">
           <i class="fal fa-info-circle fa-xs"></i>
        </span>
      </span>
      <span v-if="bigTotal !== null" slot="left-content">({{bigTotal}} total)</span>
      <slot name="filter-button">
        <a slot="right-content" @click.prevent.stop="resetFilters" :disabled="loading" class="button is-white"
           v-if="hasFilter">
          <span class="icon is-small">
            <i class="fal fa-undo-alt"></i>
          </span>
          <span>Réinitialiser les filtres</span>
        </a>
        <a slot="right-content" @click.prevent.stop="opened = !opened" :disabled="loading" class="button is-white"
           :class="{'is-active': opened}">
          <span class="icon is-small">
            <i class="fal fa-filter"></i>
          </span>
          <span v-if="hasFilter" class="badge has-badge-rounded has-badge-small is-padding-right-small"
                :data-badge="''"><span>Filtres</span></span>
          <span v-else>Filtres</span>
        </a>
      </slot>
      <a slot="right-content" v-for="a in availableActions" :disabled="loading" @click.prevent.stop="a.action"
         :class="a.linkClass">
        <span class="icon is-small">
          <i class="fal" :class="a.icon"></i>
        </span>
        <span>{{ a.text }}</span>
      </a>
    </sticky>
    <div id="wrapper-filters-top" class="is-pointer-events-none">
      <form @submit.prevent.stop="submitFilters()" @change="changeFilters()" @reset.prevent.stop="resetFilters"
            class="has-bg-white is-pointer-events-auto"
            @input="changeFilters()">
        <div class="columns is-gapless is-border-bottom is-multiline" v-show="opened">
          <div class="column is-narrow is-full">
            <slot></slot>
          </div>
        </div>
      </form>
      <div @click.prevent.stop="opened = !opened">
        <div class="has-text-centered has-text-white is-padding-top-large is-margin-bottom-small"
             v-if="!loading && opened && total >= 1">
          <h1 class="title is-3 has-text-white is-paddingless"><span>{{ total }}&nbsp;<span v-if="label"> résultat<span
            v-if="total > 1">s</span>&nbsp;</span>trouvé<span v-if="total > 1">s</span></span></h1>
          <p><a class="has-text-white is-paddingless" @click.prevent.stop="opened = !opened">Acceder à la liste</a></p>
        </div>
        <div class="has-text-centered has-text-white is-padding-top-large is-margin-bottom-small"
             v-if="!loading && opened && total === 0">
          <p><a class="has-text-white is-paddingless" @click.prevent.stop="resetFilters">Réinitialiser les filtres</a>
          </p>
        </div>
        <spinner-round v-else :isLoading="loading"></spinner-round>
      </div>
    </div>
    <div id="overlay-filters-top" class="is-overlay has-bg-primary" v-show="opened" @click.prevent.stop="opened = !opened">
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash'
  import { mapGetters } from 'vuex'
  export default {
    name: 'AppFilter',
    data () {
      return {
        opened: false
      }
    },
    props: {
      hasFilter: {
        type: Boolean,
        default: false
      },
      actions: {
        type: Array,
        required: false
      },
      label: {
        type: String,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      displayed: {
        required: false
      },
      total: {
        required: false
      },
      bigTotal: {
        required: false
      },
      helper: {
        required: false
      }
    },
    computed: {
      ...mapGetters(['currentUserProfil']),
      availableActions () {
        let availableActions = []
        this.actions.forEach(a => {
          let display = true
          if (a.display && typeof a.display === 'function') {
            display = a.display(this.data)
          } else if (a.display === false) {
            display = a.display
          }
          if (display && (!a.needProfile || a.needProfile.includes(this.currentUserProfil))) {
            availableActions.push(a)
          }
        })
        return availableActions
      },
      labelPlurialize () {
        let s = this.label
        if (this.total > 1) {
          if (s[s.length - 1] === 'u') {
            s += 'x'
          } else if (s[s.length - 1] !== 'x' && s[s.length - 1] !== 's') {
            s += 's'
          }
        }
        return s
      },
      rightContent () {
        return this.$slots['right-content'][0]
      }
    },
    methods: {
      resetFilters (e) {
        this.$store.commit('setScrollEl', null)
        this.$emit('resetFilters')
      },
      changeFilters: debounce(function () {
        this.$emit('changeFilters')
      }, 300),
      submitFilters () {}
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/utils/AppFilter.vue